import { renderMilestoneName } from "@/models/Milestone"

import { Notification, NotificationMilestoneContent } from "./Notification"

export class NotificationGoal extends Notification {
  constructor(props) {
    super(props)
  }

  get projectName() {
    return this.content?.projectName ?? ""
  }

  get milestone() {
    return this.content?.milestone
  }

  get milestoneDate() {
    if (this.content?.milestone) {
      return `${this.content.milestone.startDate} - ${this.content.milestone.endDate}`
    }
    return ""
  }

  get url() {
    return this.content?.url || "#"
  }

  get mileStoneurl() {
    return this.content?.milestoneUrl || this.content?.url || "#"
  }
  get goalUrl() {
    return this.content?.goalUrl || this.content?.url || "#"
  }

  get milestoneName() {
    return renderMilestoneName(this.content?.milestone?.title ?? "")
  }

  get totalItemsCount() {
    return this.content?.totalItemsCount ?? ""
  }

  get percentComplete() {
    const value = this.content?.percentComplete ?? this.milestone?.percentComplete
    return value != null ? Math.round(value) : ""
  }

  get currentGoalContent() {
    return this.content?.goalContent ?? this.content?.content ?? ""
  }

  get videoUrl() {
    return this.content?.videoUrl ?? ""
  }

  get important() {
    return this.content?.important ?? ""
  }

  get timeline() {
    return this.content?.timeline ?? ""
  }

  get whyNow() {
    return this.content?.whyNow ?? ""
  }

  get attachmentsMetadata() {
    return this.content?.attachmentsMetadata ?? null
  }

  get goalId() {
    const url = this.content?.goalUrl || ""
    const match = url.match(/goalId=([a-f0-9-]+)/)
    return match ? match[1] : ""
  }
}
